/* eslint-disable react/state-in-constructor */
/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactDropzone from 'react-dropzone';

import Button from '@material-ui/core/Button';

import csvToJson from '../ImportCommands/utils/converter/csvToJson';
import excelToJson from '../ImportCommands/utils/converter/excelToJson';

import { CustomPaper, Exemple, Container } from './other/style';

import { displayInAppError } from '../../utils/toast/Toast';

import {
  setProducts,
  checkIfEanAlreadyPresent,
  getBarcodeValues,
  getRequiredAttributes
} from './other/actions';
import SelectFormatDialog from '../ImportCommands/SelectFormatDialog';
import IsInStockDialog from './IsInStockDialog';

import validateProducts from './other/validate';

class DropzoneProducts extends Component {
  state = {
    acceptedFiles: [],
    openDialogIsInStock: false
  };

  handleCloseDialogIsInStock = () => {
    this.setState({ openDialogIsInStock: false });
  };

  onDrop = acceptedFiles => {
    const fileName = acceptedFiles[0].name;
    if (
      fileName.endsWith('.csv') ||
      fileName.endsWith('.xls') ||
      fileName.endsWith('.xlsx')
    ) {
      this.setState({
        acceptedFiles,
        openDialogIsInStock: true
      });
    } else {
      displayInAppError(
        'Format non supporté, veuillez importer un fichier au format suivant ( .xlsx, .xls, .csv )'
      );
    }
  };

  processing = () => {
    const file = this.state.acceptedFiles[0];
    const { name } = file;

    const reader = new FileReader();
    reader.onabort = () =>
      displayInAppError('La lecture du fichier a été interrompue');
    reader.onerror = () =>
      displayInAppError('La lecture du fichier a été interrompue');
    // Lecture du fichier
    reader.onload = () => {
      const currentFile = reader.result;
      let jsonFile;
      if (name.endsWith('.csv')) {
        jsonFile = csvToJson(currentFile, true);
      } else {
        jsonFile = excelToJson(currentFile);
      }
      // Convertion au format sympl
      if (jsonFile.length > 0) {
        this.next(jsonFile);
      }
    };
    if (name.endsWith('.csv')) {
      reader.readAsText(file);
    } else {
      reader.readAsBinaryString(file);
    }
  };

  selectedFileType = fileFormat => {
    const file = this.state.acceptedFiles[0];
    const { name } = file;
    const reader = new FileReader();
    // Lecture du fichier
    reader.onload = () => {
      const readFile = reader.result;
      let jsonFile;
      if (name.endsWith('.csv')) {
        jsonFile = csvToJson(readFile, false);
      } else {
        displayInAppError('Format de fichier non reconnu');
      }
      // Convertion au format sympl
      if (jsonFile) {
        this.next(jsonFile, fileFormat);
      } else {
        displayInAppError(
          'Erreur lors de la lecture du fichier, veuillez vérifier son format'
        );
      }
    };
    if (name.endsWith('.csv')) {
      reader.readAsText(file);
    } else {
      reader.readAsBinaryString(file);
    }
  };

  next = symplProducts => {
    const {
      currentUser,
      eanInFile,
      barcodeValues,
      dispatchCheckIfEanAlreadyExist,
      dispatchSetProducts,
      dispatchGetBarcodeValue,
      dispatchGetRequiredAttributes
    } = this.props;
    if (currentUser.company) {
      dispatchCheckIfEanAlreadyExist(symplProducts);
      dispatchGetRequiredAttributes();
      if (!barcodeValues) dispatchGetBarcodeValue();
    }
    // Ajout des données dans le store redux
    const products = symplProducts.map(product => ({
      quantity: product.quantity >= 0 ? product.quantity : 0,
      barcodeValue: product.ean13,
      name: product.name,
      material: product.material,
      color: product.color,
      size: product.size,
      countryOfOrigin: product.countryOfOrigin,
      value: product.value ? product.value : 0,
      isInsuranceRequired: product.isInsuranceRequired
        ? product.isInsuranceRequired
        : false,
      reference: product.reference,
      requiredAttributes: []
    }));
    dispatchSetProducts(products);
    products.forEach((product, index) => {
      validateProducts(product, { eanInFile, products, index, barcodeValues });
    });
  };

  render() {
    const { openDialogIsInStock } = this.state;
    return (
      <div>
        <SelectFormatDialog unknowFileType={this.selectedFileType} />
        <IsInStockDialog
          isOpen={openDialogIsInStock}
          handleCloseDialogIsInStock={this.handleCloseDialogIsInStock}
          processing={this.processing}
        />
        <CustomPaper>
          <ReactDropzone onDrop={this.onDrop}>
            {({
              getRootProps,
              getInputProps,
              isDragActive,
              isDragAccept,
              isDragReject
            }) => (
              <Container
                {...getRootProps()}
                style={{ height: '40vh' }}
                state={{ isDragActive, isDragAccept, isDragReject }}
              >
                <input {...getInputProps()} />
                <p
                  style={{
                    marginTop: '15vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  Déposer vos fichiers ici, ou cliquez pour sélectionner vos
                  fichiers
                  <br />
                  Formats supportés ( .xlsx, .xls )
                </p>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginTop: 15 }}
                >
                  Importer un fichier
                </Button>
              </Container>
            )}
          </ReactDropzone>
          <Exemple>
            <Exemple.Button
              onClick={() =>
                window.open(
                  'https://s3-eu-west-1.amazonaws.com/app.sympl.fr/public/Orders+template.xlsx'
                )
              }
            >
              <Exemple.Icon role="button" />
              <div>Télécharger le fichier excel de base</div>
            </Exemple.Button>
          </Exemple>
        </CustomPaper>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.init.currentUser,
  eanInFile: state.importProducts.eanInFile,
  barcodeValues: state.importProducts.barcodeValues
});

const mapDispatchToProps = dispatch => ({
  dispatchCheckIfEanAlreadyExist: data =>
    dispatch(checkIfEanAlreadyPresent(data)),
  dispatchSetProducts: data => dispatch(setProducts(data)),
  dispatchGetRequiredAttributes: () => dispatch(getRequiredAttributes()),
  dispatchGetBarcodeValue: () => dispatch(getBarcodeValues())
});

DropzoneProducts.propTypes = {
  currentUser: PropTypes.object.isRequired,
  eanInFile: PropTypes.array.isRequired,
  barcodeValues: PropTypes.array.isRequired,
  dispatchCheckIfEanAlreadyExist: PropTypes.func.isRequired,
  dispatchSetProducts: PropTypes.func.isRequired,
  dispatchGetBarcodeValue: PropTypes.func.isRequired,
  dispatchGetRequiredAttributes: PropTypes.func.isRequired,
  openDialogIsInStock: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(DropzoneProducts);
